module.exports = __webpack_public_path__ + "img/megalabs-small.67c3b4c5.png";